export const ru = {
    title: 'Командировка оформлена',
    description: 'Поездка согласована, а добавленные услуги оформлены',
    trip_route: 'Маршрут поездки',
};
